import { topicLabel, topicScope, voiceLabel } from '@gogrov/shared'
import type { TopicWeight } from '@/types/database'

interface TopicWeightsEditorProps {
  clientId: string
  topicWeights: TopicWeight[]
}

/**
 * The account's topic mix, as the client sees it. The mix is a 100% budget
 * with locks and voices, edited in the app's Topic Mix (enter the portal to
 * change it) so the sum and the plan cap are always checked in one place.
 */
export function TopicWeightsEditor({ topicWeights }: TopicWeightsEditorProps) {
  const rows = [...topicWeights].sort((a, b) => (b.share ?? 0) - (a.share ?? 0))
  const total = rows.reduce((n, r) => n + (r.share ?? 0), 0)
  return (
    <div className="admin-section">
      <div className="admin-section-head">
        <h2 className="admin-section-title">Topic mix</h2>
        <span className="admin-muted">{rows.length} topics · {total}%</span>
      </div>
      <p className="admin-muted">To change it, enter the portal and open Settings, Topics.</p>
      <table className="admin-table">
        <thead><tr><th>Topic</th><th>Reach</th><th>Share</th><th>Voice</th><th>Locked</th></tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id}>
              <td>{topicLabel(r.topic)}</td>
              <td>{topicScope(r.topic)}</td>
              <td>{r.share ?? 0}%</td>
              <td>{voiceLabel(r.voice)}</td>
              <td>{r.locked ? 'Yes' : ''}</td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={5}>No topics yet. The client picks them in onboarding.</td></tr>}
        </tbody>
      </table>
    </div>
  )
}
